import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { AiOutlineDown } from "react-icons/ai";
import { FaArrowRight } from "react-icons/fa";
import { Header_Menu_Items } from "../../constant/HeaderData";
import { useLocation, Link } from "react-router-dom";

const TopToolbarLink = () => {
  const location = useLocation();
  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  return (
    <div className="hidden lg:flex grow justify-center gap-8 text-base h-full">
      {Header_Menu_Items.map((item, index) => (
        <div
          key={index}
          className="relative flex"
          onMouseEnter={() => setOpenMenuIndex(index)}
          onMouseLeave={() => setOpenMenuIndex(null)}
        >
          {item.subMenu ? (
            <button
              className="hover:text-[var(--website-secondary-color)] focus:outline-none flex items-center"
              onClick={() =>
                setOpenMenuIndex(openMenuIndex === index ? null : index)
              }
            >
              <span>{item.title}</span>
              <span className="ml-2 mt-0.5">
                <AiOutlineDown size={16} />
              </span>
            </button>
          ) : (
            <Link
              to={item.pageId}
              className="hover:text-[var(--website-secondary-color)] focus:outline-none flex items-center"
            >
              <span>{item.title}</span>
            </Link>
          )}

          {item.subMenu && (
            <AnimatePresence>
              {openMenuIndex === index && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.22, ease: "easeOut" }}
                  className="fixed top-20 md:top-24 left-0 right-0 w-full bg-[var(--website-primary-color)] shadow-lg text-sm z-50"
                >
                  <div className="mx-auto max-h-[calc(100vh-128px)] max-w-6xl overflow-y-auto px-4 py-5">
                    <div className="grid grid-cols-1 gap-5 lg:grid-cols-[1fr_300px]">
                      <div className="grid grid-cols-2 gap-3 xl:grid-cols-3">
                        {item.subMenu.map((subitem, subindex) => {
                          const routePrefix =
                            item.pageId === "/services"
                              ? "/services"
                              : item.pageId === "/company"
                                ? "/company"
                                : "/details";
                          const destination = `${routePrefix}/${subitem.pageId}`;
                          const isSelected = location.pathname === destination;
                          const iconSrc = subitem.logoURL
                            ? require(`../../assets/HeaderIcons/${subitem.logoURL}`)
                            : require(`../../assets/HeaderIcons/consultation.png`);

                          return (
                            <Link
                              key={subindex}
                              to={destination}
                              aria-label={subitem.title}
                              className={`group block w-full rounded-xl border p-3 text-left transition-colors duration-150 ${
                                isSelected
                                  ? "border-[var(--website-secondary-color)] bg-[rgba(var(--website-secondary-rgb),0.1)]"
                                  : "border-white/10 bg-white/[0.07] hover:border-[rgba(var(--website-secondary-rgb),0.5)] hover:bg-white/[0.12]"
                              }`}
                              onClick={() => setOpenMenuIndex(null)}
                            >
                              <div className="flex items-start gap-3">
                                <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-white/10">
                                  <img
                                    src={iconSrc}
                                    alt={subitem.title}
                                    loading="lazy"
                                    className="h-6 w-6 object-contain"
                                  />
                                </div>
                                <div>
                                  <span
                                    className={`block text-sm font-semibold transition-colors ${
                                      isSelected
                                        ? "text-[var(--website-secondary-color)]"
                                        : "text-white group-hover:text-[var(--website-secondary-color)]"
                                    }`}
                                  >
                                    {subitem.title}
                                  </span>
                                  <p className="mt-1 text-xs leading-snug text-slate-300">
                                    {subitem.description}
                                  </p>
                                </div>
                              </div>
                            </Link>
                          );
                        })}
                      </div>

                      {item.promo && (
                        <div className="relative hidden overflow-hidden rounded-2xl lg:block">
                          <img
                            src={require(`../../assets/${item.promo.image}`)}
                            alt=""
                            aria-hidden="true"
                            className="absolute inset-0 h-full w-full object-cover"
                            loading="lazy"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-[rgba(var(--surface-dark-rgb),0.95)] via-[rgba(var(--surface-dark-rgb),0.8)] to-[rgba(var(--surface-dark-rgb),0.5)]" />
                          <div className="relative flex h-full flex-col justify-end p-5">
                            <p className="text-base font-semibold text-white">
                              {item.promo.heading}
                            </p>
                            <p className="mt-2 text-sm leading-relaxed text-slate-300">
                              {item.promo.subheading}
                            </p>
                            <Link
                              to={item.promo.ctaLink}
                              onClick={() => setOpenMenuIndex(null)}
                              className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[var(--website-secondary-color)] transition hover:gap-3"
                            >
                              {item.promo.ctaText}
                              <FaArrowRight size={12} />
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          )}
        </div>
      ))}
    </div>
  );
};

export default TopToolbarLink;
